import Rebase from 're-base';
import firebase from 'firebase/app';
import 'firebase/database';

// var app = firebase.initializeApp({
//   apiKey: 'AIzaSyCETlSYkOH6Cut5Ii31THM3j5iOiHLz89Q',
//   authDomain: 'qwales1-test-fa2c0.firebaseapp.com',
//   databaseURL: 'https://qwales1-test-fa2c0.firebaseio.com',
//   projectId: 'qwales1-test-fa2c0'   
// });

//preseli web
// var app = firebase.initializeApp({
//     apiKey: "AIzaSyDxTdAAanCY9GESUa4IuhdM7DPoCZS-2bs",
//     authDomain: "preseli-493c5.firebaseapp.com",
//     databaseURL: "https://preseli-493c5.firebaseio.com",
//     projectId: "preseli-493c5",
//     storageBucket: "preseli-493c5.appspot.com",
//     messagingSenderId: "674039325608"
// )};

var app = firebase.initializeApp({
    apiKey: "AIzaSyDK3cSmdQM5YJ45mAYOOoWSQm3Gc0e1WGE",
    authDomain: "admin-playground.firebaseapp.com",
    databaseURL: "https://admin-playground.firebaseio.com",
    projectId: "admin-playground",
    storageBucket: "admin-playground.appspot.com",
    messagingSenderId: "749890938296"
  });


var db = firebase.database(app);
var base = Rebase.createClass(db);

export default base;



// WEBPACK FOOTER //
// ./src/rebase.js